import { gql } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";

// Dispatched whenever deletion requests change (e.g. one is completed),
// so the sidebar badge refreshes without a full reload.
export const ACCOUNT_DELETIONS_UPDATED_EVENT =
  "account-deletion-requests-updated";

const PENDING_COUNT_QUERY = gql`
  query BackofficeAccountDeletionRequestsPendingCount {
    backofficeAccountDeletionRequestsPendingCount
  }
`;

export const useAccountDeletionsBadge = (enabled: boolean) => {
  const [pendingCount, setPendingCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!enabled) return;

    try {
      const apolloClientModule = await import("../../services/apolloClient");
      const { data } = await apolloClientModule.apolloClientNew.query({
        query: PENDING_COUNT_QUERY,
        fetchPolicy: "network-only",
      });
      setPendingCount(data?.backofficeAccountDeletionRequestsPendingCount ?? 0);
    } catch {
      // Badge is best-effort — never break the menu because of it
    }
  }, [enabled]);

  useEffect(() => {
    fetchCount();

    window.addEventListener(ACCOUNT_DELETIONS_UPDATED_EVENT, fetchCount);
    return () => {
      window.removeEventListener(ACCOUNT_DELETIONS_UPDATED_EVENT, fetchCount);
    };
  }, [fetchCount]);

  return { pendingCount };
};
